import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-m-financeaccountinggroup",
  "use": "icon-soc-m-financeaccountinggroup-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-m-financeaccountinggroup\">\r\n<g transform=\"translate(-80 -80) scale(1.18)\" fill=\"currentColor\">\r\n<circle cx=\"420\" cy=\"180\" r=\"28\" /><circle cx=\"512\" cy=\"512\" r=\"320\" /><path d=\"M480 288h64v96h-64zM416 416h192v64H416zM416 544h192v64H416zM480 640h64v96h-64z\" fill=\"#fff\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-m-financeaccountinggroup.svg
// module id = y05C
// module chunks = 534